import React, { useState } from "react";
import { Typewriter } from "react-simple-typewriter";

const InfiniteColoredTypewriter = () => {
    const textArray = [
        { text: "Suspicious HTTP Request Detected;", color: "blue" },
        { text: "DNS Query for Malicious Domain;", color: "green" },
        { text: "NMAP Scan Detected on Port 443;", color: "red" },
        { text: "ICMP Echo Request from External Network;", color: "orange" },
        { text: "Potential SQL Injection Attempt;", color: "purple" },
        { text: "TCP SYN Flood Attack Detected;", color: "cyan" },
        { text: "Unusual UDP Traffic on Port 53;", color: "yellow" },
        { text: "Suspicious File Upload via HTTP;", color: "pink" },
        { text: "DNS Amplification Attack Attempt;", color: "brown" },
        { text: "Brute Force Login Attempt via SSH;", color: "teal" }
      ];
    

  const [currentText, setCurrentText] = useState("");

  const handleTyping = (text) => {
    setCurrentText(text || ""); 
  };

  const currentColor =
    textArray.find((item) => currentText.includes(item.text))?.color || "black";

  return (
    <div style={{ fontSize: "3rem", fontFamily: "monospace" ,textAlign:'start',width:'100%',height:'300px'}}>
      <span style={{ color: currentColor }}>{currentText}</span>
      <Typewriter
        words={textArray.map((item) => item.text)}
        loop={0} 
        cursor
        cursorStyle="|"
        typeSpeed={60}
        deleteSpeed={60}
        delaySpeed={1000}
        onType={handleTyping}
        onDelete={handleTyping}
      />
    </div>
  );
};

export default InfiniteColoredTypewriter;
